import { useState } from "react";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { getPromoMessaging } from "../../utils/product/getPromoMessaging";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { ListItem } from "./../__shared__/ListItem/ListItem";
import { InfoOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import styles from "./FeatureMessagesDrawer.module.scss";
import FeatureMessagesDrawerFeature from "./components/FeatureMessagesDrawerFeature/FeatureMessagesDrawerFeature";
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";

type Props = {
  /**
   * An array of Message objects.
   */
  messages: (NonPromotionalMessage | PromotionalMessage)[];
};

export const FeatureMessagesDrawerUI = ({ messages }: Props) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const { featureDrawerMessages } = getPromoMessaging(messages, true);

  if (featureDrawerMessages.length === 0) {
    return null;
  }

  const labelText = (
    <div className={styles.featureMessagesListItemLabel}>
      <span>{featureDrawerMessages[0]?.title}</span>
      {featureDrawerMessages.length > 1 ? (
        <span className={styles.featureMessagesNumber}>{`+${
          featureDrawerMessages.length - 1
        }`}</span>
      ) : null}
    </div>
  );

  return (
    <>
      <ListItem
        trailingIcon={<ArrowRight size="medium" />}
        onClick={() => {
          sendEvent("FEATURES_DRAWER_OPEN");
          setDrawerIsOpen(true);
        }}
        label={labelText}
        leadingIcon={<InfoOutlined size="medium" />}
        data-testid="feature-messages-drawer-header"
        className={styles.featureMessagesListItem}
        dataComponent="FeatureMessagesDrawer"
      />
      <Drawer
        isOpen={drawerIsOpen}
        onClose={() => {
          setDrawerIsOpen(false);
        }}
      >
        {featureDrawerMessages.map((feature, index) => (
          <FeatureMessagesDrawerFeature key={index} feature={feature} />
        ))}
      </Drawer>
    </>
  );
};
